import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const ConexionRedSchema = yup.object().shape({
  caudalMedio: CantidadSchema.required(
    "errors.conexionRed.caudalMedio.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3DIA" } }),
  caudalPico: CantidadSchema.required("errors.conexionRed.caudalPico.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3H" } }),
  prestador: yup
    .object()
    .typeError("errors.conexionRed.prestador.type")
    .required("errors.conexionRed.prestador.required")
    .default(null),
});
